import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { CreatePromotionRequestButton } from '_molecules';
import { PromotionRequestsTable } from '_organisms';
import { AccessDenied } from '_templates/AccessDenied/AccessDenied';
import { getPromotionRequestsOnJob } from 'actions';
import { ACTIONS, UI, useAbility } from 'permission';
import { PromotionRequestsEmpty } from './PromotionRequestsEmpty';

const isForbiddenError = (error: unknown) => {
  const status = (error as { response?: { status?: number } })?.response?.status;
  return status === 403;
};

export const JobPromotionRequestsTab = () => {
  const { t } = useTranslation();
  const ability = useAbility();
  const { id: jobId } = useParams<{ id: string }>();
  const [accessDenied, setAccessDenied] = useState(false);

  const canViewPromotionRequests = ability.can(ACTIONS.READ, UI.PROMOTION_REQUEST_VIEW);

  useEffect(() => {
    if (!canViewPromotionRequests) setAccessDenied(true);
  }, [canViewPromotionRequests]);

  if (accessDenied || !canViewPromotionRequests) {
    return <AccessDenied />;
  }

  return (
    <PromotionRequestsTable
      fetchRequests={params =>
        getPromotionRequestsOnJob(jobId, params, { showErrorNotification: false }).catch(error => {
          if (isForbiddenError(error)) setAccessDenied(true);
          return Promise.reject(error);
        })
      }
      cardTitle={t('translation:job_promotion_requests_tab.title')}
      extra={<CreatePromotionRequestButton jobId={jobId} />}
      emptyComponent={<PromotionRequestsEmpty jobId={jobId} />}
    />
  );
};
